import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardTitle, Row, Col, Table, Badge, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import axiosInstance from '../../api/Axios';

const PassedProperties = () => {
  const navigate = useNavigate();
  const { token } = useAuth();
  const [properties, setProperties] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchPassedProperties();
  }, []);

  const fetchPassedProperties = async () => {
    setLoading(true);
    setError('');
    try {
      const headers = { Authorization: `Token ${token}` };

      // Fetch all properties and filter for passed inspections
      const propertiesResponse = await axiosInstance.get('/api/properties/all-created/', { headers });
      const allProperties = Array.isArray(propertiesResponse.data.properties) 
        ? propertiesResponse.data.properties 
        : [];
      const passedProperties = allProperties.filter(property => 
        property.inspection_status === 'inspection_passed'
      );

      // Fetch all rooms to count passed rooms per property
      const roomsResponse = await axiosInstance.get('/api/rooms/all/', { headers });
      const allRooms = Array.isArray(roomsResponse.data) ? roomsResponse.data : [];
      
      console.log('Passed properties:', passedProperties);
      console.log('All rooms:', allRooms);
      console.log('Sample room data:', allRooms[0]);
      
      setProperties(passedProperties);
      setRooms(allRooms);
    } catch (err) {
      console.error('Error fetching passed properties:', err);
      setError('Failed to load passed properties. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const getPassedRoomCount = (propertyId) => {
    return rooms.filter(room => 
      room.property_id === propertyId && 
      room.inspection_status === 'inspection_passed'
    ).length;
  };

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3 className="mb-0">
              <i className="bi bi-check-circle me-2"></i>
              Passed Properties
            </h3>
            <Button
              color="secondary"
              size="sm"
              onClick={() => navigate('/inspector-dashboard')}
            >
              <i className="bi bi-arrow-left me-2"></i>
              Back to Dashboard
            </Button>
          </div>

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
        </Col>
      </Row>

      <Row>
        <Col md="12">
          <Card>
            <CardBody>
              <CardTitle tag="h5" className="mb-4">
                All Passed Property Inspections ({properties.length})
              </CardTitle>

              {loading ? (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : properties.length === 0 ? (
                <div className="text-center py-4 text-muted">
                  <i className="bi bi-inbox" style={{ fontSize: '3rem' }}></i>
                  <p className="mt-3 mb-0">No passed property inspections found.</p>
                </div>
              ) : (
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>Property ID</th>
                      <th>Trading Name</th>
                      <th>Address</th>
                      <th>Provider</th>
                      <th>Status</th>
                      <th>Inspection Date</th>
                      <th>Inspector</th>
                      <th>Rooms</th>
                    </tr>
                  </thead>
                  <tbody>
                    {properties.map((property) => {
                      const passedRoomCount = getPassedRoomCount(property.id);
                      return (
                      <tr key={property.id}>
                        <td>#{property.id}</td>
                        <td><strong>{property.trading_name || 'N/A'}</strong></td>
                        <td>
                          {property.addresslines && (
                            <div className="small">
                              {property.addresslines}<br />
                              {property.city}, {property.province}
                            </div>
                          )}
                        </td>
                        <td>{property.user_email || 'N/A'}</td>
                        <td>
                          <Badge color="success">
                            <i className="bi bi-check-circle me-1"></i>
                            Passed
                          </Badge>
                        </td>
                        <td>
                          {property.inspection_date 
                            ? new Date(property.inspection_date).toLocaleDateString()
                            : 'N/A'
                          }
                        </td>
                        <td>
                          {property.inspector_name || 'N/A'}
                        </td>
                        <td>
                          <Button
                            color="primary"
                            size="sm"
                            onClick={() => navigate(`/inspector-dashboard/property-passed-rooms/${property.id}`)}
                            disabled={passedRoomCount === 0}
                          >
                            <i className="bi bi-door-closed me-1"></i>
                            {passedRoomCount} {passedRoomCount === 1 ? 'Room' : 'Rooms'}
                          </Button>
                        </td>
                      </tr>
                      );
                    })}
                  </tbody>
                </Table>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PassedProperties;
